// removed by extract-text-webpack-plugin
module.exports = {"hidden":"pNNti","visuallyhidden":"_1gV_b","hide-text":"_2-SvX","center":"_2p8u0","noprint":"NmKq6","videoRatio":"_3-e72","square":"_1jaWj","audio":"_2ypP6","root":"frh73"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-inline-video/styles/feature.scss
 ** module id = 134
 ** module chunks = 2
 **/